<template>
  <section class="invoice-preview-wrapper">
    <b-row
      v-if="campaign"
      class="invoice-preview"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
        >
          <!-- Header -->
          <b-card-body class="invoice-padding m-0 p-0">

            <div class="d-flex justify-content-between flex-md-row flex-column">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <TrackHelpsLogo height="28" />
                  <h3 class="text-primary invoice-logo">
                    {{ appName }} - <span style="font-size:0.8em">顧客管理小幫手</span>
                  </h3>
                </div>
              </div>
            </div>
            <h1 class="text-center card-text font-weight-bolder display-3 text-dark">
              打卡快速通關
            </h1>
            <div class="mb-0" />
            <vue-qr
              :logo-src="require('@/assets/images/qrcode/cross.png')"
              :logo-corner-radius="20"
              :text="lineUrl"
              :size="288"
              :callback="createQrcode"
              :margin="0"
              :bind-element="false"
            />
            <b-img
              v-if="qrcode"
              :src="qrcode"
              class="mr-1 mx-auto d-block img-fluid"
            />
          </b-card-body>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>
              <b-col
                cols="12"
                class="mb-0 text-center"
              >
                <span class="display-3 font-weight-bold text-primary">{{ campaign.campaignName }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="2"
                class="m-0 p-0 text-center"
              >
                <img :src="campaign.logoImgURL">
              </b-col>
              <b-col
                cols="12"
                md="2"
              />
              <b-col
                cols="12"
                md="6"
                class="m-0 pt-2 text-left"
              >
                <b-col
                  cols="12"
                  class="mb-1"
                >
                  <span class="display-4 font-weight-bold text-dark">
                    <feather-icon
                      size="30"
                      icon="GlobeIcon"
                      class="text-primary"
                    /> {{ campaign.slug }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  class="mb-1"
                >
                  <span class="h1 font-weight-bold text-dark ">
                    <feather-icon
                      size="30"
                      color="primary"
                      icon="PhoneIcon"
                      class="text-primary"
                    /> {{ campaign.contactNumber }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  class="mb-1"
                >
                  <span class="h1 font-weight-bold text-dark">
                    <feather-icon
                      size="30"
                      icon="MapPinIcon"
                      class="text-primary"
                    /> {{ campaign.address }}
                  </span>
                </b-col>
              </b-col>
              <b-col
                cols="12"
                md="2"
                class="m-0 p-0 text-center"
              >
                <img :src="campaign.govImgURL">
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr>

          <!-- Note -->
          <b-card-body class="invoice-padding text-center m-0 p-0">
            <span
              class="h2 font-weight-bold"
            >一起加入實名幫 <span class="text-primary">TrackHelps.com</span> 顧客管理小幫手</span>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-send-invoice
            variant="primary"
            class="mb-75"
            block
            :disabled="$isMobile()"
            @click="printCampaign"
          >
            {{ btnText }}
          </b-button>

          <!-- Button: Edit -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="editCampaign"
          >
            編輯
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { mapGetters } from 'vuex'
import {
  BRow, BCol, BCard, BCardBody, BButton, VBToggle, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { $themeConfig } from '@themeConfig'
import TrackHelpsLogo from '@/views/Logo.vue'
import VueQr from 'vue-qr'
import mergeImages from 'merge-images'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    TrackHelpsLogo,
    VueQr,
  },
  data() {
    return {
      appName: $themeConfig.app.appName,
      appLogoImage: $themeConfig.app.appLogoImage,
      lineUrl: `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}/${encodeURI(this.$route.params.slug)}`,
      qrcode: undefined,
      btnText: (this.$isMobile()) ? '不支援手機列印' : '列印',
    }
  },
  computed: {
    ...mapGetters(['campaign', 'user']),
  },
  mounted() {
    store.dispatch('getCampaign', { slug: this.$route.params.slug, cuid: this.user.uid })
  },
  methods: {
    editCampaign() {
      router.push(`/campaign/edit/${this.$route.params.slug}`)
    },
    /* eslint-disable global-require */
    printCampaign() {
      setTimeout(() => {
        if (!document.execCommand('print', false, null)) {
          window.print()
        }
      }, 500)
    },
    createQrcode(dataUrl) {
      const logo = require('@/assets/images/qrcode/logoframe.png')
      mergeImages([logo, { src: dataUrl, x: 204, y: 177 }], {
      })
        .then(b64 => {
          this.qrcode = b64
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
.display-5 { font-size:2.5rem; }

@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>

<style>
  @media print {
      @page {
          margin-top: 0;
          margin-bottom: 0;
      }
      body {
          padding-top: 10px;
          padding-bottom: 72px ;
      }
  }
</style>
